export default __webpack_public_path__ + "static/media/forex-vps-net.ae911d40.svg";